import { render, staticRenderFns } from "./FormSubcon.vue?vue&type=template&id=b8138422&scoped=true"
import script from "./FormSubcon.vue?vue&type=script&lang=js"
export * from "./FormSubcon.vue?vue&type=script&lang=js"
import style0 from "./FormSubcon.vue?vue&type=style&index=0&id=b8138422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8138422",
  null
  
)

export default component.exports